<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-04-20 11:15:47
 * @LastEditors: liang
 * @LastEditTime: 2021-10-11 16:16:31
-->
<template>
  <div class="list">
    <div class="commonbox">
      <div class="w1200">
        <breadcrumb :datarow='breadcrumbObj' :islist='true'></breadcrumb>
      </div>
    </div>
    <div class="commonbox">
      <div class="w1200" style="overflow: hidden">
        <!-- 左树 -->
        <div class="treediv">
          <div class="flsxname">分类筛选</div>
          <el-tree v-if="showtree"
            :data="treeData"
            :props="defaultProps"
            node-key="id"
            ref="listTree"
            highlight-current
            :default-expand-all='!!selectId'
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
        <!-- 右列表 -->
        <div class="indexlist"  v-loading='listload'>
          <div class="sxdiv">
            <el-button-group style="float:left">
              <el-button type="primary" style="cursor:default">排序方式</el-button>
              <el-button :plain="true" type="info" @click="init"
                >默认</el-button
              >
              <el-button
                type="info"
                plain
                @click="sxFun(1)"
                v-if="dataForm.teachingCommentRatio  == ''"
                >好评率</el-button
              >
              <el-button
                type="info"
                plain
                @click="sxFun(1)"
                v-if="dataForm.teachingCommentRatio  == '1'"
                >好评率 <i class="el-icon-caret-bottom"></i
              ></el-button>
              <el-button
                type="info"
                plain
                @click="sxFun(1)"
                v-if="dataForm.teachingCommentRatio  == '0'"
                >好评率 <i class="el-icon-caret-top"></i
              ></el-button>
              <!-- <el-button
                type="info"
                plain
                @click="sxFun(2)"
                v-if="dataForm.teachingClick == ''"
                >点击量</el-button
              >
              <el-button
                type="info"
                plain
                @click="sxFun(2)"
                v-if="dataForm.teachingClick == '1'"
                >点击量 <i class="el-icon-caret-bottom"></i
              ></el-button>
              <el-button
                type="info"
                plain
                @click="sxFun(2)"
                v-if="dataForm.teachingClick == '0'"
                >点击量 <i class="el-icon-caret-top"></i
              ></el-button> -->
              <el-button
                type="info"
                plain
                @click="sxFun(3)"
                v-if="dataForm.teachingPrice == ''"
                >价格</el-button
              >
              <el-button
                type="info"
                plain
                @click="sxFun(3)"
                v-if="dataForm.teachingPrice == '1'"
                >价格 <i class="el-icon-caret-bottom"></i
              ></el-button>
              <el-button
                type="info"
                plain
                @click="sxFun(3)"
                v-if="dataForm.teachingPrice == '0'"
                >价格 <i class="el-icon-caret-top"></i
              ></el-button>
            </el-button-group>
            <div style="display: inline-block; padding-left: 15px;float:left">
              <!-- <el-input
                style="width: 120px"
                v-model="dataForm.minprice"
                type="number"
                min="0"
                placeholder="最小价格"
              ></el-input>
              <span> - </span>
              <el-input
                style="width: 120px"
                type="number"
                min="0"
                v-model="dataForm.maxprice"
                placeholder="最大价格"
              ></el-input>
              <el-button style="margin-left: 15px" type="primary" plain @click="getIdList"
                >查 询</el-button
              >-->
              <!-- <el-checkbox v-model="dataForm.isZy" label="是否自营" border @change="changeHandle"></el-checkbox> -->
            </div>
          </div>
          <ul>
            <li class="li" v-for="item in listArr" :key="item.id">
              <div class="img" @click="todetail(item)">
                <img :src="minioUrl+item.teachingLogoUrl" />
              </div>
              <div class="name" @click="todetail(item)">
               {{item.teachingName}}
              </div>
              <div class="priceother">
                <span class="green">{{item.teachingPrice?item.teachingPrice:'免费'}}</span>
                <span class="deptName">{{item.deptName}}</span>
              </div>
              <!-- <div class="bottominfo">
                <div>
                  <span class="shoucang"
                    ><i class="el-icon-star-off"></i>收藏</span
                  >
                  <span style="padding-left: 20px"
                    ><i class="el-icon-chat-line-round"></i>22</span
                  >
                </div>
                <span>已售 0 件</span>
              </div> -->
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              background
              :current-page="dataForm.page"
              :page-size="dataForm.limit"
              layout="total,prev, pager, next"
              :total="total"
              @current-change="pageCurrentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import mixins from '@/mixins/index'
export default {
  name: 'list',
  mixins: [mixins],
  data () {
    return {
      selectId: '',
      breadcrumbObj: {},
      showtree: false,
      listload: false,
      dataForm: {
        teachingName: '',
        isZy: false,
        teachingCommentRatio: '',
        teachingClick: '',
        teachingPrice: '',
        // minprice: '',
        // maxprice: '',
        limit: 12,
        page: 1,
        buyDeptId: ''
      },
      total: 0,
      listArr: [],
      treeData: [],
      minioUrl: '',
      defaultProps: {
        children: 'children',
        label: 'typeName'
      },
      leftnavarr: []
    }
  },
  components: { breadcrumb },
  methods: {
    init () {
      // 重置数据
      Object.assign(this.$data.dataForm, this.$options.data().dataForm)
      if (!this.$route.query.buyDeptId) {
        delete this.dataForm['buyDeptId']
      } else {
        this.dataForm.buyDeptId = this.$route.query.buyDeptId
      }
      this.getIdList()
    },
    sxFun (val) {
      var name = ''
      if (val === 1) {
        name = 'teachingCommentRatio'
        this.dataForm.teachingClick = ''
        this.dataForm.teachingPrice = ''
      } else if (val === 2) {
        name = 'teachingClick'
        this.dataForm.teachingCommentRatio = ''
        this.dataForm.teachingPrice = ''
      } else if (val === 3) {
        name = 'teachingPrice'
        this.dataForm.teachingCommentRatio = ''
        this.dataForm.teachingClick = ''
      }
      if (this.dataForm[name] === '') {
        this.dataForm[name] = '1'
      } else if (this.dataForm[name] === '1') {
        this.dataForm[name] = '0'
      } else if (this.dataForm[name] === '0') {
        this.dataForm[name] = '1'
      }
      this.getIdList()
    },
    handleNodeClick (data) {
      if (data.pids === '0') {
        // 路由背景更改
        this.leftnavarr.forEach((item, index) => {
          if (item.id === data.id) {
            this.$store.dispatch('setNavIndex', index)
          }
        })
      } else {
        this.leftnavarr.forEach((item, index) => {
          if (item.id === data.pids.split(',')[0]) {
            this.$store.dispatch('setNavIndex', index)
          }
        })
      }
      this.$router.push({ path: '/list', query: { selectId: data.id } })
    },
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getIdList()
    },
    getListTree () {
      this.$get('/clientNotAuth/getDetailsTree?id=' + this.selectId).then(res => {
        if (res.code === 0) {
          this.treeData = res.data.trainTeachtypeDict
          this.$nextTick(() => {
            this.$refs.listTree.setCurrentKey(this.selectId)
            this.getIdList()
          })
        }
      })
    },
    getSearchListTree () {
      this.$get('/clientNotAuth/tree').then(res => {
        if (res.code === 0) {
          this.treeData = res.data
          this.getIdList()
        }
      })
    },
    getIdList () {
      this.listload = true
      this.$get('/clientNotAuth/getCoursePage', { ...this.dataForm, ...{ teachingTypeId: this.selectId, ssProvince: '130000', ssCity: localStorage.getItem('citycode') } }).then(res => {
        this.listload = false
        if (res.code === 0) {
          this.listArr = res.data.list
          this.total = res.data.total
        }
      })
    },
    todetail (item) {
      this.$router.push({ path: '/detail', query: { selectId: this.selectId ? this.selectId : item.teachingType, tid: item.id, tName: item.teachingName } })
    },
    changeHandle () {
      this.getIdList()
    }
  },
  watch: {
    $route: {
      handler (to) {
        if (to.path === '/list') {
          this.leftnavarr = JSON.parse(localStorage.getItem('leftnavarr'))
          this.showtree = false
          this.minioUrl = process.env.VUE_APP_minio
          this.selectId = this.$route.query.selectId || ''
          if (!this.$route.query.buyDeptId) {
            delete this.dataForm['buyDeptId']
          } else {
            this.dataForm.buyDeptId = this.$route.query.buyDeptId
          }
          this.dataForm.teachingName = this.$route.query.teachingName || ''
          this.$nextTick(() => {
            this.showtree = true
          })
          if (this.selectId) {
            this.breadcrumbObj = this.familyTree(this.leftnavarr, this.selectId)[0]
            this.getListTree()
          } else {
            if (!this.$route.query.buyDeptId) {
              this.breadcrumbObj = { typeName: this.dataForm.teachingName }
              this.getSearchListTree()
            } else {
              this.breadcrumbObj = { typeName: '单位课程' }
              this.getSearchListTree()
            }
          }
        }
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.treediv {
  border: 1px solid #ddd;
  width: 210px;
  float: left;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.flsxname {
  text-align: center;
  font-weight: bold;
  padding: 10px 0;
  background: #eee;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
div/deep/.is-current > div > .el-tree-node__label {
  color: #409eff;
  font-weight: bold;
}
.indexlist {
  float: right;
  width: 972px;
}
.indexlist h3 {
  position: relative;
  font-size: 24px;
  color: #333;
  font-weight: 500;
  letter-spacing: 5px;
  line-height: 36px;
  text-align: center;
  padding: 30px 0;
}
.indexlist ul {
  overflow: hidden;
}
.indexlist ul li {
  position: relative;
  border-radius: 8px 8px 0 0;
  z-index: 1;
  float: left;
  width: 230px;
  margin-right: 17px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(7, 17, 27, 0.1);
  background: #fff;
}
.indexlist ul li:hover .name {
  color: #f56c6c;
  cursor: pointer;
}
.indexlist ul li:nth-child(4n) {
  margin-right: 0;
}
.indexlist ul li .name {
  font-size: 15px;
  height: 40px;
  margin: 10px 8px;
   text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.indexlist ul li .priceother {
  display: flex;
  padding: 0 8px;
  width: 214px;
  align-items: center;
  justify-content: space-between;
}
.indexlist ul li .priceother .deptName{white-space: nowrap;width: 160px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;}
.indexlist ul li > div {
  float: left;
  overflow: hidden;
}
.indexlist ul li .img {
  width: 100%;
  height: 125px;
  overflow: hidden;
  cursor: pointer;
}
.indexlist ul li .img img {
  transition: all 0.3s ease-out;
  width: 100%;
  height: 125px;
  float: left;
}
.img:hover img {
  float: left;
  transform: scale(1.2);
}
.indexlist ul li .bottominfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 8px 0 8px;
  width: 214px;
}
.indexlist ul li .bottominfo span,
.indexlist ul li .bottominfo i {
  color: #888;
}
.indexlist ul li .bottominfo i {
  font-size: 16px;
}
.indexlist ul li .bottominfo .shoucang {
  cursor: pointer;
}
.sxdiv {
  padding-bottom: 20px;overflow: hidden;
}
.pagination {
  text-align: right;
}
</style>
